export default __webpack_public_path__ + "static/appStore-a256073128865cd858a32b87a3a8b55b.svg";